import { render, staticRenderFns } from "./zxwzPage.vue?vue&type=template&id=0e8e21f6&scoped=true&"
import script from "./zxwzPage.vue?vue&type=script&lang=js&"
export * from "./zxwzPage.vue?vue&type=script&lang=js&"
import style0 from "./zxwzPage.vue?vue&type=style&index=0&id=0e8e21f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e21f6",
  null
  
)

export default component.exports